// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyTwoToneSvg from "@fishx/icons-svg/es/asn/PropertySafetyTwoTone";
import FishxIcon from '../components/FishxIcon';

var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyTwoToneSvg
  }));
};

PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
export default React.forwardRef(PropertySafetyTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PropertySafetyTwoTone.js
// module id = 3866
// module chunks = 0